import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import EquipmentSearch from '../components/EquipmentSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        let findBackground = this.el.dataset.background;
        let canChangeUrl = this.el.dataset.canchangeurl;
        let target = this.el.dataset.target;
        // let onlyProf = this.el.dataset.prof;
        // if (onlyProf != '1') {
        let    onlyProf = 0
        // }
        let el = this.el
        
        const app = createApp({
            template: '<EquipmentSearch background="'+findBackground+'" prof="'+onlyProf+'" canChangeUrl="'+canChangeUrl+'" target="'+target+'" />',
            components: {
                EquipmentSearch
            },
            data() {
                return {
                    title: el.dataset.title || '',
                    domains: JSON.parse(el.dataset.domains || '[]'),
                    labs: JSON.parse(el.dataset.labs || '[]'),
                    categories: JSON.parse(el.dataset.categories || '[]'),
                }
            },
            mounted() {
                // console.log(this.categories)
            },
        })
        app.mount(self.el)
    }
}